import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	SkladmistopId: null as number | null,
	SkladpneuOzn: null as number | null,
	Text: null as string | null,
	Popis: null as string | null,
	PsmKapacita: null as number | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VyrazenPrp: null as boolean | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SkladpneuOzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
